<template>
    <div ref="checkbox-container" class="ci-checkbox-2">
        <input :disabled="disabled" ref="checkbox" type="checkbox" :id="'checkbox-' + _uid" v-model="internalValue" />
        <label
            ref="checkbox-label"
            :for="'checkbox-' + _uid"
            :style="'background: ' + (value || indeterminate ? checkedBackgroundColor : backgroundColor) + ' !important'"
        >
            <icon v-if="indeterminate" class="indeterminate-icon icon" name="minus" />
            <icon v-else-if="some" class="some-icon icon" name="minus" />
            <icon v-else-if="disabled" class="disabled-icon icon" name="slash" />
            <icon v-else class="checked-icon icon" name="check" />
        </label>
    </div>
</template>

<script>
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/minus'
import 'vue-awesome/icons/slash'

export default {
    props: {
        size: {
            default: '16',
        },
        backgroundColor: {
            default: 'var(--primary-1)',
        },
        checkedBackgroundColor: {
            default: 'var(--accent)',
        },
        value: {
            default: false,
        },
        indeterminate: {
            default: false,
        },
        disabled: {
            default: false,
        },
        some: {
            default: false,
        },
    },
    data() {
        return {
            internalValue: this.value,
        }
    },
    watch: {
        size() {
            this.setupSize()
        },
        indeterminate() {
            this.setIndeterminate(this.indeterminate)
        },
        value() {
            this.internalValue = this.value
        },
        internalValue() {
            this.$emit('input', this.internalValue)
            this.$emit('change', this.internalValue)
        },
    },
    methods: {
        setIndeterminate(value) {
            this.$refs['checkbox'].indeterminate = value
        },
        setupSize() {
            this.$refs['checkbox-container'].style.height = this.size + 'px'
            this.$refs['checkbox-container'].style.width = this.size + 'px'
            this.$refs['checkbox-label'].style.height = this.size + 'px'
            this.$refs['checkbox-label'].style.width = this.size + 'px'
            // set padding
            this.$refs['checkbox-label'].style.padding = this.size / 4 + 'px'
        },
    },
    mounted() {
        this.internalValue = this.value
        this.setupSize()
    },
}
</script>

<style lang="scss" scoped>
.ci-checkbox-2 {
    height: max-content;
    width: max-content;
    display: inline-block;
    [type='checkbox'] {
        display: none;
    }
    label {
        margin: 0px;
        position: absolute;
        border-radius: 2px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        &.icon {
            width: 100%;
            height: 100%;
        }
    }
    // NOT CHECKED STYLE
    [type='checkbox']:not(:checked) + label {
        .checked-icon {
            display: none !important;
        }
    }
}
</style>
